import { render, staticRenderFns } from "./collectorUpgrade.vue?vue&type=template&id=648b374c&scoped=true&"
import script from "./collectorUpgrade.vue?vue&type=script&lang=js&"
export * from "./collectorUpgrade.vue?vue&type=script&lang=js&"
import style0 from "./collectorUpgrade.vue?vue&type=style&index=0&id=648b374c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "648b374c",
  null
  
)

export default component.exports